import pageContext from 'salvo-lite/context'
import ChangeClass from './components/ChangeClass'
import Select from './components/Select'
import Slick from './components/Slick'
import Preload from './components/Preload'
import Sticky from './components/Sticky'
import AddToCart from './components/AddToCart'
import Currency from './components/Currency'
import ScrollTo from './components/ScrollTo'
import Parallax from './components/Parallax'
import Slide from './components/Slide'
import Variants from './components/Variants'
import RelatedProducts from './components/RelatedProducts'
import Search from './components/Search'
import SearchPage from './components/SearchPage'
import SideCart from './components/SideCart'
import CartUpsell from './components/CartUpsell'
import RegisterTags from './components/RegisterTags'
import CustomWishlist from './components/CustomWishlist'
import CartCount from './components/CartCount'
import LoyaltyClick from './components/LoyaltyClick'

import Addresses from './pages/Addresses'
import Login from './pages/Login'
import Collection from './pages/Collection'
import Product from './pages/Product'
import Faq from './pages/Faq'
import Cart from './pages/Cart'

const components = {
    'change-class': ChangeClass,
    'select': Select,
    'slick': Slick,
    'preloader': Preload,
    'sticky': Sticky,
    'add-to-cart': AddToCart,
    'currency-form': Currency,
    'scroll-to': ScrollTo,
    'parallax': Parallax,
    'slide': Slide,
    'variants': Variants,
    'related-products': RelatedProducts,
    'search': Search,
    'search-page': SearchPage,
    'side-cart': SideCart,
    'cart-upsell': CartUpsell,
    'register-tags': RegisterTags,
    'custom-wishlist': CustomWishlist,
    'cart-count': CartCount,
    'loyalty-click': LoyaltyClick
}

const pages = {
    'customers/addresses': Addresses,
    'customers/login': Login,
    'collection': Collection,
    'collection.educator': Collection,
    'product': Product,
    'product.course': Product,
    'page.faq': Faq,
    'cart': Cart
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js